module.exports = __webpack_public_path__ + "media/images/2_3_1-0dd41134c72a22c2501a951564ca30b8.png";